export function convertDatesToArray(startDate, endDate) {
   const dates = [];
   let current = new Date(startDate);
   const end = new Date(endDate);
   while (current <= end) {
      const yyyy = current.getFullYear();
      const mm = String(current.getMonth()).padStart(2, '0');
      const dd = String(current.getDate()).padStart(2, '0');
      dates.push(`${yyyy}${mm}${dd}`);
      current.setDate(current.getDate() + 1);
   }
   return dates;
}
